import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';

import 'rc-tooltip/assets/bootstrap.css';

const Icon = React.forwardRef(
    (
        {
            id,
            className,
            faIcon,
            fasIcon,
            farIcon,
            falIcon,
            iconClass,
            materialIcon,
            color,
            onClick,
            onMouseEnter,
            onMouseLeave,
            tooltip,
            tooltipProps,
            disabled,
            disabledReason,
        },
        ref,
    ) => {
        const onClickHandler = (...args) => {
            if (disabled) {
                return;
            }

            onClick?.(...args);
        };

        let icon = (
            <div
                ref={ref}
                id={id}
                className={className}
                onClick={onClickHandler}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={{ color }}
            >
                {faIcon && <i className={`fa fa-${faIcon}`} />}
                {fasIcon && <i className={`fas fa-${fasIcon}`} />}
                {farIcon && <i className={`far fa-${farIcon}`} />}
                {falIcon && <i className={`fal fa-${falIcon}`} />}
                {materialIcon && (
                    <i className="material-icons">{materialIcon}</i>
                )}
                {iconClass && <i className={iconClass} />}
            </div>
        );

        let tooltipContent = tooltip;

        if (disabled) {
            tooltipContent = disabledReason;
        }

        if (tooltipContent) {
            icon = (
                <Tooltip
                    placement="bottom"
                    trigger={['hover']}
                    overlay={tooltipContent}
                    {...tooltipProps}
                >
                    {icon}
                </Tooltip>
            );
        }

        return icon;
    },
);

Icon.propTypes = {
    className: PropTypes.string,
    faIcon: PropTypes.string,
    fasIcon: PropTypes.string,
    farIcon: PropTypes.string,
    falIcon: PropTypes.string,
    materialIcon: PropTypes.string,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    disabled: PropTypes.bool,
    disabledReason: PropTypes.string,
};

Icon.defaultProps = {
    faIcon: undefined,
    fasIcon: undefined,
    farIcon: undefined,
    falIcon: undefined,
    materialIcon: undefined,
    iconClass: undefined,
    className: undefined,
    onClick: undefined,
    onMouseEnter: undefined,
    onMouseLeave: undefined,
    disabled: false,
    disabledReason: undefined,
};

export default Icon;
